<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
        <div class="mb-1">
          <label for="colFormLabel" class="col-form-label">Payroll Category</label>
          <v-select
              placeholder="Select Payroll Category"
              v-model="payrollCategory"
              :options="payrollCategoryList"
              :reduce="name => name.value"
              label="name"
          />
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
        <div class="mb-1">
          <label for="colFormLabel" class="col-form-label">Calculation Period</label>
          <v-select
              placeholder="Select Calculation Period"
              v-model="calculationPeriod"
              :options="payHeadCalculationPeriod"
              :reduce="name => name.value"
              label="name"
          />
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-3 col-lg-2  mb-1">
        <div class="mb-1">
          <label for="colFormLabel" class="col-form-label">Start Date</label>
          <vField
              v-model="startDate"
              name="date"
              id="date"
              type="date"
              class="form-control"
          />
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2  mb-1">
        <div class="mb-1">
          <label for="colFormLabel" class="col-form-label">End Date</label>
          <vField
              v-model="endDate"
              name="date"
              id="date"
              type="date"
              class="form-control"
          />
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
        <button
            style="min-width: 64px;"
            @click="onClickToGo"
            class="btn btn-primary btn-block waves-effect waves-float waves-light"
        > Process
        </button>
      </div>
    </div>
    <div class="card" style="min-height: 400px">
      <div class="col-12 mt-2 mb-4">
         <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th class="text-center">Payroll Category</th>
            <th class="text-center">Calculation Period</th>
            <th class="text-center">Start Date</th>
            <th class="text-center">End Date</th>
            <th class="text-center">Total Earning</th>
            <th class="text-center">Total Deduction</th>
            <th class="text-center">Total Net Payable</th>
            <th class="text-center">Status</th>
            <th class="text-center">Remarks</th>
            <th class="text-center">Action</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in payrollProcessList" :key="i">
            <td class="text-center text-capitalize">{{ item.payroll_category_name }}</td>
            <td class="text-center">{{ item.payroll_period_name }}</td>
            <td class="text-center">{{ item.payroll_start_date }}</td>
            <td class="text-center">{{ item.payroll_end_date }}</td>
            <td class="text-center">{{ item.total_earning }}</td>
            <td class="text-center">{{ item.total_deduction }}</td>
            <td class="text-center">{{ item.total_net_payable }}</td>
            <td class="text-center text-capitalize">{{ item.payroll_approval_status_name }}</td>
            <td class="text-center">{{ item.remarks }}</td>
            <td v-if="['failed'].includes(item.approval_status)" class="text-center">
              <button class="btn btn-primary btn-sm"
                      title="Reprocess"
                      @click="reprocess(item)"
                      style="cursor: pointer"
              >
                <i class="fas fa-sync"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <p v-if="payrollProcessList.length < 0" class="text-center mt-5">No data</p>
      </div>
      </div>
    </div>

    <div class="px-2 pt-2 position-absolute bottom-0 mt-4">
      <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
    </div>

  </div>
</template>

<script setup>
import Pagination from '@/components/atom/Pagination'
import {inject, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const store = useStore();
const route = useRoute();
const router = useRouter();
const payrollProcessList = ref([])
const loading = ref(false)
const params = ref({
  offset: 20,
});
const emit = defineEmits(['reprocess']);
const payHeadCalculationPeriod = ref([]);
const payrollCategoryList = ref([]);
const calculationPeriod = ref('')
const payrollCategory = ref('')
const startDate = ref('')
const endDate = ref('')
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const {
  fetchPayrollProcessData
} = handleHrPayroll()

const {
  fetchTypes,
  createPayrollProcessData
} = handleHrPayroll()

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getPayrollProcessList();
}

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}
const getPayrollProcessList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  query += '&approval_status=in_process,failed'

  loading.value = true
  payrollProcessList.value = []

  await fetchPayrollProcessData(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    payrollProcessList.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}
const reprocess = (item) => {
  emit('reprocess', item);
  getPayrollProcessList()
};

const createPayrollProcess = async () => {
  const confirmed = confirm("Are you sure you want to process? Please confirm all require setups are complete.");
  if (!confirmed) return;

  const query = getQuery();
  loading.value = true

  await createPayrollProcessData(query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getTypes = async () => {
  let query =`?company_id=${route.params.companyId}`;
  await fetchTypes(query).then(res => {
    if (!res.status){
      payHeadCalculationPeriod.value = [];
      return
    }

    const data = res.data || {};
    payHeadCalculationPeriod.value = data.payHeadCalculationPeriod || [];
    payrollCategoryList.value = data.payrollCategory || [];

  }).catch(err => {
    console.log(err)
  })
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;
  if (payrollCategory.value) query += '&payroll_category=' + payrollCategory.value;
  if (calculationPeriod.value) query += '&calculation_period=' + calculationPeriod.value;
  if (startDate.value) query += '&start_date=' + startDate.value;
  if (endDate.value) query += '&end_date=' + endDate.value;
  return query;
}

const onClickToGo = () => {
  createPayrollProcess();
}

onMounted(() => {
  Promise.all([
    getPayrollProcessList(),
    getTypes()
  ])
})
</script>
